// extracted by mini-css-extract-plugin
export var legendIndicator = "_8c-1";
export var legendRight = "_8c-0";